import React from 'react';
import './assets/scss/themes.scss';
import Route from './Routes';
import WhatsAppButton from './common/pages/whatsAppButton';
import CallBackModal from './common/pages/callBackModal';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
    <React.Fragment>
      <Route />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
    />
      {/* <CallBackModal /> */}
      <WhatsAppButton />
    </React.Fragment>
  );
}

export default App;
